const origin = window.location.origin.includes('kameimei.cn') ? "http://bzyspgc.caams.org.cn" : window.location.origin
const protocol = window.location.origin.includes('kameimei.cn') ? "http:" : window.location.protocol

const DOMAIN = {
  IMG: `${protocol}//qn5839.htx.cc`,
  BACKSTAGE: origin,
  WEBSITE: origin
}

export default DOMAIN
